module.exports = __webpack_public_path__ + "static/media/focus-bg.3a404a82.svg";